const defaultValues = {
  defaultSelectValue: '-',
};

export default defaultValues;
